import { render, staticRenderFns } from "./BatchImportComponent.vue?vue&type=template&id=74ccbb67"
import script from "./BatchImportComponent.vue?vue&type=script&lang=js"
export * from "./BatchImportComponent.vue?vue&type=script&lang=js"
import style0 from "./BatchImportComponent.vue?vue&type=style&index=0&id=74ccbb67&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports